import { render, staticRenderFns } from "./DialogAddMediathekItem.vue?vue&type=template&id=e6c8d5fe&scoped=true"
import script from "./DialogAddMediathekItem.vue?vue&type=script&lang=js"
export * from "./DialogAddMediathekItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c8d5fe",
  null
  
)

export default component.exports